import {useEffect, useState} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'

import {
  PACK_MODE,
  PICK_MODE,
} from '../../../common/constants/PackingOrderModal.js'
import PackLine from './PackLine.js'
import {
  packingOrderLinesFlattenedForDisplaySelector,
  packPanelFormSelector,
} from './packPanelSelectors.js'
import {useSelector} from '../../../store.js'
import {
  showImgsOrderDetailSelector,
  usesInventorySelector,
} from '../../../data/company.js'

export default function PackLines() {
  const [previousID, setPreviousID] = useState(null)
  const {orderNumbers, mode} = useSelector(packPanelFormSelector) || {}
  const packingOrderLines = useSelector(
    packingOrderLinesFlattenedForDisplaySelector,
  )
  const showImgsOrderDetail = useSelector(showImgsOrderDetailSelector)
  const usesInventory = useSelector(usesInventorySelector)
  const id = orderNumbers.join('')

  useEffect(() => {
    setPreviousID(id)
  }, [id])

  return (
    <table className="table">
      <thead>
        <tr>
          <th className="table__th table__th--top-border v-align-middle th-width-40">
            <div className="flex align-items-center">
              <div>
                <span className="lh-0 margin-right-10">Product Name/SKU</span>
              </div>
            </div>
          </th>
          {mode === PICK_MODE && usesInventory && (
            <>
              <th className="table__th table__th--top-border th-width-15 v-align-middle align-center">
                POH
              </th>
              <th className="table__th table__th--top-border th-width-15 v-align-middle align-center">
                AOH
              </th>
            </>
          )}
          <th className="table__th table__th--top-border th-width-15 v-align-middle align-center">
            Qty Ordered
          </th>
          <th className="table__th table__th--top-border border-left--light th-width-15 v-align-middle align-center">
            Qty {mode === PACK_MODE ? 'Verified' : 'Picked'}
          </th>
        </tr>
      </thead>
      <TransitionGroup
        key={id}
        component="tbody"
        className="table__tbody--lines table__tbody--packing-modal table__tbody--v-align-middle"
      >
        {packingOrderLines
          .filter((line) => line.verifiedQuantity < line.orderedQuantity)
          .map((line) => (
            <CSSTransition
              key={`${id}${line.path}`}
              classNames="success-fade"
              timeout={{exit: 1000}}
              unmountOnExit
              exit={previousID === id}
            >
              {(status) => (
                <PackLine
                  line={line}
                  status={status}
                  showImgsOrderDetail={showImgsOrderDetail}
                  usesInventory={usesInventory}
                />
              )}
            </CSSTransition>
          ))}
      </TransitionGroup>
    </table>
  )
}
